import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconOpenBook(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='open-book_svg__a'>
            <path d='M1.395 3h22.59v20.293H1.394Zm0 0' />
          </clipPath>
          <clipPath id='open-book_svg__b'>
            <path d='M11 .707h9V23h-9Zm0 0' />
          </clipPath>
        </defs>
        <g clipPath='url(#open-book_svg__a)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.41176}
            d='M18.336 4.605c1.473-.234 2.96-.359 4.453-.37a.49.49 0 0 1 .45.288.5.5 0 0 1 .038.184v14.84a.473.473 0 0 1-.473.469C15 20.113 12.689 22.59 12.689 22.59V6.809s-2.31-2.473-10.102-2.575a.49.49 0 0 0-.45.29.5.5 0 0 0-.034.183v14.84c0 .125.05.242.136.332a.48.48 0 0 0 .332.137c7.805.097 10.118 2.574 10.118 2.574'
          />
        </g>
        <g clipPath='url(#open-book_svg__b)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.41176}
            d='M12.688 22.125a5.7 5.7 0 0 1 1.539-3.246 7.77 7.77 0 0 1 4.109-2.316V1.875a.5.5 0 0 0-.059-.215.5.5 0 0 0-.156-.16.55.55 0 0 0-.465-.063 7.34 7.34 0 0 0-3.43 2.145 5.7 5.7 0 0 0-1.538 3.242'
          />
        </g>
      </svg>
    </>
  )
}
IconOpenBook.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconOpenBook
